'use strict';

/**
 *
 * @name: apiSubscriptionsService
 *
 */

function ApiSubscriptionsService(
  $rootScope,
  $http,
  $q) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function deleteSubscription(contentId, contentType) {
    console.log('dele')
    var target = $rootScope.apiUrlNew + '/subscription?' +
      '&UserId=' + $rootScope.profile.id + '&ContentId=' + contentId + '&contentType=' + contentType;

    return $http.delete(target);
  }

  function getTopics() {

    var target = $rootScope.apiUrlBak + '/topic?topicType=unsubscribe';

    return $http.get(target);
  }

  function getSubscriptions(contentType) {
    console.log('get',$rootScope.profile.id,contentType)
    var target = $rootScope.apiUrlNew + '/subscription?' +
      '&UserId=' + $rootScope.profile.id + (contentType ? '&contentType=' + contentType : '');
    var deffered = $q.defer();

    $http
      .get(target)
      .success(function(res) {

        deffered.resolve(res.items);
      }).error(function(err) {

        deffered.reject(err);
      });

    return deffered.promise;
  }

  function setSubscription(contentId, contentType) {

    var data = {
      UserId: $rootScope.profile.id,
      ContentId: contentId,
      contentType: contentType
    };

    var target = $rootScope.apiUrlNew + '/subscription';

    return $http.post(target, data);
  }

  function subscribePicks() {

    var data = {
      nownessPicks: true
    };
    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.profile.id;

    return $http.put(target, data);
  }

  function unsubscribePicks() {

    var data = {
      nownessPicks: false
    };
    var target = $rootScope.apiUrlNew + '/user/' + $rootScope.profile.id;

    return $http.put(target, data);
  }

  function unsubscribeReport(topicId, message) {

    var data = {
      TopicId: topicId,
      message: message
    };
    var target = $rootScope.apiUrlBak + '/unsubscription';
    return $http.post(target, data);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    deleteSubscription: deleteSubscription,
    getSubscriptions: getSubscriptions,
    getTopics: getTopics,
    setSubscription: setSubscription,
    subscribePicks: subscribePicks,
    unsubscribePicks: unsubscribePicks,
    unsubscribeReport: unsubscribeReport
  };
}

export default ApiSubscriptionsService;



// WEBPACK FOOTER //
// ./app/components/_api/subscriptions.service.js